import React from 'react'
import PropTypes from 'prop-types'

const VideoIframe = ({title, videoSrc, height}) => {
    return (
        <iframe
            width="100%"
            height={height || 'auto'}
            src={videoSrc}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
        />
    )
}

VideoIframe.propTypes = {
    title: PropTypes.string,
    videoSrc: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default VideoIframe
